import * as React from 'react'
import { SVGProps } from 'react'
const SvgNeckties = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path d="m12.838 7.447 4.174-3.964V0H2.988v3.483l4.174 3.964.633-.978.47 1.087-1.594 10.25L10 20l3.33-2.193-1.594-10.25.47-1.088.632.978Zm2.932-4.498-2.702 2.567-1.093-1.688 3.795-2.143V2.95Zm-1.743-1.707L10.931 2.99H9.07L5.973 1.242h8.054ZM6.932 5.516 4.23 2.949V1.685l3.795 2.143-1.093 1.688ZM10 18.512 8.021 17.21l1.417-9.113h1.124l1.417 9.113L10 18.512Zm.686-11.658H9.314l-.707-1.64.636-.982h1.514l.636.983-.707 1.639Z" />
  </svg>
)
export default SvgNeckties
